
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dvfbF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $42omo = parcelRequire("42omo");


var $6g1oe = parcelRequire("6g1oe");

var $4bbbfbab738b30e1$exports = {};
$4bbbfbab738b30e1$exports = new URL("spaceWelcome.e675216a.svg", import.meta.url).toString();


class $9d49f37cc8ab51c0$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    removeHeightAndOverflowForLegacyPage() {
        // Remove once https://product-fabric.atlassian.net/browse/CONFSIM-1635 is released
        // Proper fix has been done in the back-end velocity template
        const div = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.querySelector('body > div:first-of-type');
        if (div && div.style.height === '100vh') {
            div.style.height = '';
            div.style.overflow = '';
        }
    }
    render() {
        this.removeHeightAndOverflowForLegacyPage();
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style", null, `
  /* Applies to global "ADG3" font families. */
  body, body.aui-layout { font-family: ${"var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"}; }

  /* Resets the background colors to white (which were previously set to gray by AUI */
  body { background-color: ${"var(--ds-surface, #FFFFFF)"}; }
  div#full-height-container { background-color: ${"var(--ds-surface, #FFFFFF)"}; }

  body .aui-page-panel { border:none; position:inherit; margin:0; }

  /* Make the header transparent on legacy pages that contain the ADG3 sidebar. */
  body #main-header { background-color:transparent !important; }

  /* Make the secondary navigation on legacy pages look slightly nicer. This should be replaced with an Atlaskit component eventually. */
  body .aui-navgroup-horizontal { background-color: transparent; margin:0 0 24px 0; border-top:none; }
  body .aui-navgroup-horizontal .aui-nav a { color: ${"var(--ds-text, #292A2E)"}; }
  body .aui-navgroup-horizontal .aui-nav a:hover { background-color:transparent; text-decoration:underline; }
  body .aui-navgroup-horizontal .aui-nav > .aui-nav-selected a { border-bottom:3px solid ${"var(--ds-border-selected, #1868DB)"}; }
  body .aui-navgroup-horizontal .aui-nav > .aui-nav-selected a:before,
  body .aui-navgroup-horizontal .aui-nav > .aui-nav-selected a:after { border:none; }


  /*************************************************/
  /* Begin items for just the space welcome dialog */
  /*************************************************/
  #space-welcome-dialog .dialog-panel-body {
    background: url(${(0, (/*@__PURE__*/$parcel$interopDefault($4bbbfbab738b30e1$exports)))}) no-repeat 0px 20px;
    background-size: 450px 300px;
  }

  #space-welcome-dialog .dialog-panel-body h1 {
    color: ${"var(--ds-text, #292A2E)"};
    font: ${"var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"}
    font-weight: ${"var(--ds-font-weight-regular, 400)"}
    width: 293px;
    height: 58px;
  }

  #space-welcome-dialog .dialog-panel-body .space-description {
    padding-right: 0px;
    color: ${"var(--ds-text, #292A2E)"};
    line-height: 20px;
    height: 200px;
    font-size: 16px;
    padding-left: 541px;
  }
  #space-welcome-dialog .dialog-panel-body .space-description li {
    padding-bottom: 5px;
  }
  /***********************************************/
  /* End items for just the space welcome dialog */
  /***********************************************/


  /*************************************************************************/
  /* Begin section common to the welcome, page create and space create     */
  /* dialogs (can't currently differentiate between create space and page) */
  /*************************************************************************/

  #create-dialog,
  #space-welcome-dialog {
    /* Consistent background color for whole dialog */
    background-color: ${"var(--ds-surface, #FFFFFF)"};
    /* Took common minimum padding away from other areas to create a more consistent base padding */
    padding: 24px 24px 19px 24px;
  }
  #create-dialog .dialog-title,
  #space-welcome-dialog .dialog-title {
    /* conceal the border */
    border-bottom: 0px solid ${"var(--ds-border-inverse, #FFFFFF)"};
    /* most padding of title and button panel absorbed at top level by dialog padding */
    padding: 0 0 14px 0;
  }
  #create-dialog h2.dialog-title ,
  #space-welcome-dialog h2.dialog-title {
    /* Height of actual text */
    line-height: 30px;

    /* Text styling */
    color: ${"var(--ds-text, #292A2E)"};
    font-size: 20px;
    font-weight: ${"var(--ds-font-weight-medium, 500)"};
  }
  /*******************************************************************/
  /* End common to the welcome, page create and space create dialogs */
  /* (can't currently differentiate between create space and page)   */
  /*******************************************************************/

  /* Needed to keep z-index of inline message creation popup on text highlight above Nav v2 drawer */
  /* The transform is a trick to stop the Nav v2 scrollbar from showing up over the top of the popup (Chrome bug) */
  #com-atlassian-confluence div#inline-dialog-selection-action-panel.aui-inline-dialog {
    z-index: 200;
    transform: translateZ(0px);
  }

  .ProseMirror ol[data-node-type=decisionList] {
    list-style-type: none;
    padding-left: 0;
  }
`));
    }
}
module.exports["default"] = $9d49f37cc8ab51c0$export$2e2bcd8739ae039;

});


//# sourceMappingURL=LegacyCssOverrides.e5fbafa3.js.map
